<template lang="pug">
  ServicePopup(v-if="show_popup", @closePopup="closePopup")
    .popup
      .popup__content
        .popup__left
          h2.popup__title {{ $t("popup.title") }}
          .popup__text {{ $t("popup.text") }}
          .popup__timer
            .popup__timer-title {{ $t("popup.timer") }}
            .popup__timer-count 00 : {{ getZero(timer_count) }}
        .popup__img
          img(src="~@/assets/images/popup-prize.png")

      button.button.button-medium-x15.popup__button(@click="openReg")
        span {{ $t("popup.button") }}

</template>

<script>
import Cookie from "js-cookie";
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";
import ServicePopup from "@static_promo_pages/common/components/service-popup/vue/ServicePopup";

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("global");

export default {
  name: "PresentPopup",

  components: {
    ServicePopup,
  },

  mixins: [MobileDetection],

  data() {
    return {
      show_popup: false,

      timer_count: 60,
      id_timer_popup: false,
      id_timer_tab: false,
      id_timer_animate: false,
      default_tab_name: document.title,
      default_tab_icon: this.getFavicon(),
    };
  },

  computed: {
    ...mapGetters(["isUserNotAuthed", "isUserAuthedNotRegistered"]),
  },

  created() {
    this.initPopup();
  },

  methods: {
    closePopup() {
      this.show_popup = false;

      window.removeEventListener("blur", this.disableTab);
      window.removeEventListener("focus", this.activeTab);
      clearInterval(this.id_timer_popup);
    },

    openPopup() {
      this.show_popup = true;
      Cookie.set("_la_popup_present", "1", {
        expires: 365,
        path: "/",
      });
    },

    startTimer() {
      if (!this.id_timer_popup) {
        this.id_timer_popup = setInterval(() => {
          if (this.timer_count === 0) {
            clearInterval(this.id_timer_popup);
            this.activeTab();
            this.closePopup();
          }
          this.timer_count -= 1;
        }, 1000);
      }
    },

    getZero(number) {
      return number < 10 ? "0" + number : number;
    },

    disableTab() {
      this.openPopup();
      this.changeFavicon(require("../../assets/images/popup-favicon.png"));
      this.aimateTextTab();
    },

    activeTab() {
      clearInterval(this.id_timer_tab);
      clearInterval(this.id_timer_animate);
      document.title = this.default_tab_name;
      this.changeFavicon(this.default_tab_icon);

      this.startTimer();
    },

    getFavicon() {
      return document.querySelector("link[rel=\"icon\"]").href;
    },

    changeFavicon(link) {
      let favicon_list = document.querySelectorAll("link[rel=\"icon\"]");

      favicon_list.forEach(favicon => {
        favicon.href = link;
      });
    },

    aimateTextTab() {
      let state_animate = 1;

      this.id_timer_animate = setInterval(() => {
        document.title = state_animate ? this.$t("popup.not_active_tab") : "**********";
        state_animate = !state_animate;
      }, 1000);
    },

    initPopup() {
      if (!Cookie.get("_la_popup_present") && !this.is_mobile) {
        window.addEventListener("blur", this.disableTab);
        window.addEventListener("focus", this.activeTab);
      }
    },

    openReg() {
      this.closePopup();

      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
  },
};
</script>
